export default __webpack_public_path__ + "static/interview-image-385969fd9306f8c223a1321a0a3aa7c0.svg";